import React from 'react';

import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export interface BellIconButtonProps {
  totalNotificationsCount: number;
  unseenNotificationsCount: number;

  onClick: React.MouseEventHandler;
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    top: -1,
  },
}));

const BellIconButton = (props: BellIconButtonProps) => {
  const { totalNotificationsCount, unseenNotificationsCount, onClick } = props;

  const BellIconToRender = totalNotificationsCount === 0 ? NotificationsNoneIcon : NotificationsActiveIcon;

  return (
    <IconButton onClick={onClick} size="large">
      <StyledBadge badgeContent={unseenNotificationsCount} invisible={unseenNotificationsCount === 0}>
        <BellIconToRender style={{ color: 'white' }} />
      </StyledBadge>
    </IconButton>
  );
};

export default BellIconButton;
